module.exports = __webpack_public_path__ + "static/media/mobile-app-development.801173e1.svg";